import {
  ContratBDL,
  IDeleteContratRattache,
  IPostSaveParams,
  IPostTarifAutoParams,
  IPostTarifParams,
} from '../bdl/contrat';

export const ContratServices = () => ({...ContratBDL()});

export const ContratRattacherService = () => {
  const {
    getMontant,
    renouvellerContratRattache,
    deleteContrat,
    renouvellerAuto,
    getMontantAuto,
  } = ContratBDL();

  return {
    getMontant: async (data: IPostTarifParams) => {
      return await getMontant(data);
    },
    renouvellerContratRattache: async (data: IPostSaveParams) => {
      return await renouvellerContratRattache(data);
    },
    renouvellerContratAuto: async (data: FormData) =>
      await renouvellerAuto(data),

    deleteContrat: async (data: IDeleteContratRattache) => {
      return await deleteContrat(data);
    },
    getMontantAuto: async (data: IPostTarifAutoParams) => {
      return await getMontantAuto(data);
    },
  };
};
